

import React, { useEffect, useState } from "react";
import "./MobileSlider.css";
import "./ScienceAndTechSlider.css"
import { Select } from "antd";
import { Citys, cities, location1 } from "../../component/Location";
import { Mobiles } from "../../component/env";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getExtraField } from "../../store/ProductFilterSlice";
const images = [
    "https://2.bp.blogspot.com/-hExUYJIIdLs/UQqv5crKCXI/AAAAAAAADi4/QCkLdQWj8U4/s1600/Flowers.Gifts.jpg5",
    "https://www.arabianflora.com/blog/wp-content/uploads/2022/04/Importance-of-Sending-Flowers-and-Gifts-on-Ramadan1-1024x766.jpg",
    "https://w0.peakpx.com/wallpaper/440/568/HD-wallpaper-macro-flower-single-nature-flowers-ai-orange-large-macro.jpg",
    "https://th.bing.com/th/id/OIP.oJ6NPWK1TRWYU1QiUJ2XmAHaEJ?rs=1&pid=ImgDetMain",
    "https://th.bing.com/th/id/R.4fc5850a9e5f2380d4c3ea3d8c909ae4?rik=THpT9huZDPzYwQ&riu=http%3a%2f%2f4.bp.blogspot.com%2f_De3HUQ-A6EA%2fTSLSmcLe8_I%2fAAAAAAAAAAo%2fPbQK1hLCTR0%2fs1600%2fvalentines%2bday%2bgifts%2b%25252817%252529.jpg&ehk=sZXtGJysNgi9LwEc6AIvh27YO7e38qtvC1cn7vNyZ8s%3d&risl=&pid=ImgRaw&r=0",
    "https://th.bing.com/th/id/OIP.BOhpeo2Io0cca2iIL8xV7AHaEo?rs=1&pid=ImgDetMain",
    "https://th.bing.com/th/id/OIP.5c7gbHAJsqR-bZ-H5thMgwHaHa?w=1000&h=1000&rs=1&pid=ImgDetMain"
];

const GiftsAndFlowerSlider = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [visible1, setVisible1] = useState(false);
    const handleDropdownVisibleChange = (open) => {
        setVisible1(open);
    };
    const [visible2, setVisible2] = useState(false);
    const handleDropdownVisibleChange2 = (open) => {
        setVisible2(open);
    };
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 2000);
        return () => clearInterval(interval);
    }, [images.length]);

    const mobilestyle = {
        height: "200px",
        width: "100%",
    };
    const desktopstyle = {
        height: "340px",
        width: "90%",
        marginLeft: "1.5cm",
        marginRight: "2.5cm",
        borderRadius: "20px",
    };
    const mobstyle = {
        display: "flex",
        flexDirection: "column",
    };
    const deskstyle = {
        display: "flex",
        flexDirection: "row",
    };

    const [selectedFilter, setSelectedFilter] = useState(null);

    const [loading, setLoading] = useState(false); // Setting up a state variable 'loading' and its setter function 'setLoading' with initial value 'false'
    const disptach = useDispatch();
    const dispatch = useDispatch();
    // Accessing the Redux dispatch function
    const [errorMessage, setErrorMessage] = useState(null);
    const [extraFieldCopy, setExtraFieldCopy] = useState({});
    const [city, setCity] = useState();
    const [category, setCategory] = useState();
    const [cityError, setCityError] = useState("");
    const [categoryError, setCategoryError] = useState("");
    const [searchSending, setsearchSending] = useState({
        subCategoryType: null,
        subCategoryValue: null,
        City: null,
        searchValue: null,
        category: "ScienceAndTech",
        minPrice: null,
        maxPrice: null,
    }); // State for search form data

    //   const disptach = useDispatch(); // Initializing useDispatch hook

    // Event handler for input field changes
    const handleChange = (e) => {
        var name = e.target.name;
        var value = e.target.value;
        setExtraFieldCopy({ [name]: value });
        // setsearchSending({ ...searchSending, [name]: value });
        // disptach(getExtraField(searchSending)); // Dispatching getExtraField action
    };

    useEffect(() => {
        // Update searchSending state with the selected filter value
        if (selectedFilter !== null) {
            setsearchSending((prevState) => ({
                ...prevState,
                category: selectedFilter,
            }));
        }
    }, [selectedFilter]);
    return (
        <>
            <div
                className="scienceslide scienceslide-awi-24 mt-4 mb-3"
            // style={isMobile ? mobstyle : deskstyle}
            >

                <div className="carousel-innerscience24-awi-24">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className={`carousel-item${index === activeIndex ? " active" : ""
                                }`}
                        >
                            <img
                                src={image}
                                alt={`Slide ${index}`}
                                style={isMobile ? mobilestyle : desktopstyle}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default GiftsAndFlowerSlider ;
